import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Heading } from '@ruby-labs/ui-core-kit';

import { BaseContext } from 'context/base.context';

import { useLocalStorage } from 'hooks/use-local-storage.hook';
import { useSaveAnswers } from 'hooks/use-save-answers.hook';

import { UNIT_SYSTEM } from 'constants/body-height-weight';
import { MultipleLocalStorageKeys } from 'constants/local-storage';

import { NextButton } from 'components/next-button';
import { BodyHeightWeightInputs } from 'components/body-height-weight-inputs';
import { UserEligibilityKeys } from 'constants/user-eligibility';

export const BodyWeight = () => {
    const { t } = useTranslation();
    const saveAnswers = useSaveAnswers();

    const { pageConfiguration } = useContext(BaseContext);

    const bodyHeightWeightKeys = MultipleLocalStorageKeys.bodyHeightWeightKeys;

    const [pageError, setPageError] = useState(false);
    const { setPageValue: setEligibleBMIValue } = useLocalStorage({
        key: UserEligibilityKeys.isBMIValueEligible,
        defaultValue: true,
    });

    const [disabledButtonState, setDisabledButtonState] = useState(true);
    const [errors, setError] = useState({});

    const handleClick = () => {
        if (disabledButtonState) {
            return;
        }

        const data = {
            unit: bodyHeightWeightUnitSystem,
            weight: bodyWeightKg
        };

        saveAnswers({
            key: bodyHeightWeightKeys.weightKg,
            itemQuestion: { question: t('body-weight-title'), value: `Weight: ${data.weight} kg` },
        });
        pageConfiguration.handleOnPageComplete(data);
    };

    const { pageValue: bodyHeightWeightUnitSystem } =
        useLocalStorage({
            key: bodyHeightWeightKeys.unitSystem,
            defaultValue: UNIT_SYSTEM.metric
    });

    const { pageValue: bodyWeightKg } = useLocalStorage({
        key: bodyHeightWeightKeys.weightKg,
        defaultValue: '',
    });

    useEffect(() => {

        setPageError(() => {
            // @ts-ignore
            return Object.keys(errors).some((key) => errors[key]);
        });

    }, [JSON.stringify(errors)]);

    useEffect(() => {
        const btnState = pageError || !bodyWeightKg;

        setDisabledButtonState(btnState);

    }, [
        bodyHeightWeightUnitSystem,
        bodyWeightKg,
        pageError
    ]);

    return (
        <>
            <Heading title={t('body-weight-title')} subtitle={t('body-weight-subtitle')} />

            <BodyHeightWeightInputs heightInput={false} idealWeightInput={false} setEligibleBMIValue={setEligibleBMIValue} setInputError={setError} pageError={pageError} />

            <NextButton onClick={handleClick} disabled={disabledButtonState} />
        </>
    );
};
